// https://vuex.vuejs.org/en/getters.html

export default {
  fees(state) {
    return state.fees;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
